<template>
  <div
    class="select-box-holder width-10"
    v-validate="errors"
    v-has-value="value"
    v-select-box
    :class="{disabled}"
  >
    <div class="input-box">
      <div class="input-holder">
        <div
          class="wrapper"
          :class="{'has-options': options.length > 0}"
        >
          <!-- Desktop select-box -->
          <v-select
            v-if="!isMobile"
            :options="options"
            :filterable="!!filterable"
            :value="value"
            @input="$emit('input', $event)"
            @search="$emit('searching', $event)"
            :tabindex="disabled ? -1 : null"
            :filter="filter"
          >
            <span slot="no-options">Žiadne dáta sa nenašli.</span>
          </v-select>

          <!-- Mobile select -->
          <select
            class="mobile-select"
            v-if="isMobile"
            :value="mobileValue"
            @input="mobileEmit($event.target.value)"
            autocomplete="off"
            :disabled="disabled"
            :tabindex="disabled ? -1 : 0"
          >
            <option :value="''"></option>
            <option
              v-for="(option, index) in options"
              :key="option.name$ || `${index + 1}${Math.round(Math.random() * 10000)}`"
              :value="option.label"
            >{{option.label}}</option>
          </select>
        </div>

        <!-- Label -->
        <slot></slot>

        <!-- Dropdown icon -->
        <i class="icon icon--dropdown"></i>
      </div>

      <!-- Tooltip -->
      <div v-if="!isTooltip" class="tooltip"></div>
      <tooltip v-if="isTooltip" ref="tooltip">
        <slot name="tooltip"></slot>
        <template slot="button-cancel" v-if="!!this.$slots['button-cancel']">
          <slot name="button-cancel"></slot>
        </template>
      </tooltip>
    </div>

    <div class="validation-output">
      <slot name="validations"></slot>
    </div>
  </div>
</template>

<script>
import { Tooltip } from "union_components";
import VSelect from "vue-select";

export default {
  name: 'SelectBox',
  components: {
    Tooltip, VSelect,
  },
  props: {
    errors: {
      required: false,
      type: Array,
      default: () => [],
    },
    value: {
      required: true,
    },
    options: {
      required: true,
      type: Array,
      default: () => [],
    },
    filterable: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    disableOptionsValidation: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    filter: {
      required: false,
      type: Function,
      default(options, search) {
        return options.filter(option => {
          let label = this.getOptionLabel(option);
          if (typeof label === "number") { label = label.toString(); }
          return this.filterBy(option, label, search);
        });
      }
    },
  },
  computed: {
    /*
    * Vrati true ak je to mobilne zariadenie Android|iOS|Windows Phone
    * */
    isMobile() {
      return [
        /Android/i, /webOS/i, /iPhone/i, /iPad/i,
        /iPod/i, /BlackBerry/i, /Windows Phone/i,
      ].some((toMatchItem) => navigator.userAgent.match(toMatchItem));
    },
    /*
    * Vrati true ak datum ma tooltip
    * */
    isTooltip() {
      return !!this.$slots.tooltip;
    },
    /*
    * Hodnota pre mobilnych/nativny select
    * */
    mobileValue() {
      if (!this.value) return '';
      return this.value.label;
    },
  },
  methods: {
    /*
    * Emitnutie hodnoty z <select>, pretoze select nevie cez v-model
    * emitnut objekt ale iba string
    * */
    mobileEmit(label) {
      if (!label) this.$emit('input', null);
      else {
        const foundOption = this.options.find((option) => option.label === label);
        if (!foundOption) this.$emit('input', null);
        else this.$emit('input', foundOption);
      }
    },
    /*
    * Pozrie ci option sa nachadza v options ak nie tak emitne null
    * */
    checkValidProperty(options) {
      if (this.disableOptionsValidation) return;
      if (!options.some((option) => option && this.value && option.name$ === this.value.name$)) {
        this.$emit('input', null);
      }
    },
    /*
    * Otvori tooltip
    * */
    openTooltip() {
      const { tooltip } = this.$refs;
      if (tooltip) tooltip.handleTooltip(true);
    },
  },
  watch: {
    /*
    * Ak sa zmeni property options spusti funkciu checkValidProperty.
    * */
    options: {
      handler(newValue) {
        this.checkValidProperty(newValue);
      },
      deep: true,
    },
  },
  /*
  * Ak pri inicializacie komponentu existuje v modeli hodnota
  * cekni ci je v pohode.
  * */
  mounted() {
    if (this.value) this.checkValidProperty(this.options);
  },
};
</script>
